module.exports = __webpack_public_path__ + "img/certif_010.691b6ab7.jpg";